import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../CustomComponent/toast";
import StepRoutes from "../../Routes/steps_routes";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import performRequest from "../../api/request";
import { FieldArray, Form, Formik } from "formik";
import Footer from "../../Components/Footer/footer";
import CustomCheckbox from "../../CustomComponent/custom_checkbox";
import CustomSelect from "../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import { NewLeadInfo } from "../../SchemaInfo/info";
import { NewLeadSchema } from "../../Schemas/New Leads System/add_new_lead.schema";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomRadioButton from "../../CustomComponent/custom_radio";
import { useLocation } from "react-router-dom";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { toTitleCase } from "../../Components/Functions/word.fun";

const AddNewLeads = () => {
  const store = useSelector((store) => store.login.user);
  const location = useLocation();
  const leadData = location?.state;
  const [leadsInfo, setLeadsInfo] = useState({ ...NewLeadInfo, ...leadData });

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  const navigate = useNavigate();

  const today = new Date();
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 30);
  const maxDateString = maxDate.toISOString().split("T")[0];
  const [activeField, setActiveField] = useState("preferred_language");

  function getFollowupDate(input) {
    const today = new Date();

    const map = {
      "followup today": 0,
      "followup in one day": 1,
      "followup in two day": 2,
      "followup in four day": 4,
      "followup in one week": 7,
      "followup in two week": 14,
      "followup in one month": 30,
    };

    if (!map[input]) {
      return input;
    }
    const daysToAdd = map[input.toLowerCase()] || 0;
    today.setDate(today.getDate() + daysToAdd);

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  // const fieldScoreRules = {
  //   preferred_language: 2,
  //   first_name: 0,
  //   last_name: 0,
  //   email: 5,
  //   contact_number: 0,
  //   whatsapp_number: 5,
  //   enquiry_related_to: 3,
  //   prior_knowledge_of_farming: 10,
  //   interested_in: 10,
  //   farm_construction_location: 10,
  //   farm_construction_state: 0,
  //   farm_land_type: 10,
  //   total_area_available: 10,
  //   facilities: 10,
  //   tentative_start_time: 15,
  //   looking_for_loan: 10,
  //   notes: 0,
  //   origin: 0,
  //   lead_status: 0,
  //   lead_alloted_to: 0,
  //   followUp: 0,
  // };

  const fieldScoreRules = {
    interested_in: 27,
    tentative_start_time: 10,
    prior_knowledge_of_farming: 8,
    facilities: 8,
    farm_land_type: 8,
    total_area_available: 8,
    looking_for_loan: 8,
    farm_construction_location: 8,
    email: 5,
    whatsapp_number: 5,
    enquiry_related_to: 3,
    preferred_language: 2,
  };

  // const calculateLeadScore = (values) => {
  //   let score = 0;

  //   Object.keys(fieldScoreRules).forEach((field) => {
  //     if (values[field] && values[field] !== "" && values[field] !== null) {
  //       score += fieldScoreRules[field];
  //     }
  //   });

  //   return score;
  // };

  const calculateLeadScore = (values) => {
    let score = 0;

    Object.keys(fieldScoreRules).forEach((field) => {
      const value = values[field];

      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) && // empty array check
        !(typeof value === "boolean" && value === false) // false boolean ignore
      ) {
        score += fieldScoreRules[field];
      }
    });

    return score;
  };

  const handelSubmit = (values, actions) => {
    if (
      values.contact_number === "0000000000" ||
      values.contact_number === "1111111111" ||
      values.contact_number === "2222222222" ||
      values.contact_number === "3333333333" ||
      values.contact_number === "4444444444" ||
      values.contact_number === "5555555555" ||
      values.contact_number === "6666666666" ||
      values.contact_number === "7777777777" ||
      values.contact_number === "8888888888" ||
      values.contact_number === "9999999999" ||
      values.contact_number === "1234567890" ||
      values.contact_number === "9876543210" ||
      values.contact_number === "0987654321"
    ) {
      Toast("error", "Invalid phone number");
    } else if (
      values.followUp &&
      values.followUp.length == 0 &&
      values?.enquiry_related_to === "Sales"
    ) {
      Toast("error", "Please add next followUp before create lead");
    } else if (
      values.followUp &&
      values.followUp.length > 0 &&
      !values.followUp[values.followUp.length - 1].followUpDate
    ) {
      Toast("error", "Please Add followUp Date before Create");
    } else {
      if (values.followUp && values.followUp.length > 0) {
        values.followUp = values.followUp.map((followup) => {
          // if (followup?.followUpDate) {
          //   followup = {
          //     ...followup,
          //     followUpDate: getFollowupDate(followup?.followUpDate),
          //   };
          // }
          if (followup.followupTaken && !followup.followupTakenDate) {
            return {
              ...followup,
              followupTakenDate: new Date().toISOString().split("T")[0],
            };
          } else {
            return followup;
          }
        });
      }

      let score = calculateLeadScore(values);

      // let applicable_for_closer = false;
      // if (score >= 90 && values?.interested_in?.includes("farm construction")) {
      //   applicable_for_closer = true;
      // }
      Object.keys(values).forEach((key) => {
        if (typeof values[key] === "string") {
          values[key] = values[key].trim();
        }
      });

      let data = {
        ...values,
        leadScore: score,
        farm_construction_location: toTitleCase(
          values.farm_construction_location
        ),
        farm_construction_state: toTitleCase(values.farm_construction_state),
        farm_land_type: toTitleCase(values.farm_land_type),
        first_name: toTitleCase(values.first_name),
        funding_type: toTitleCase(values.funding_type),
        last_name: toTitleCase(values.last_name),
        location_type: toTitleCase(values.location_type),
      };

      setLoading(true);
      performRequest("POST", "/leads_v2/create_lead", data)
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Leads generated successfully!");

            setTimeout(() => {
              navigate(`/leads-tracking-system`);
            }, 1000);
          } else if (res.status === 200) {
            Toast("error", res.data.message);
          } else {
            Toast("error", "Error while uploading");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const checkTouched = (obj) => {
    if (obj.followUp === "" && obj.followUpDate === "") {
      return false;
    } else {
      return true;
    }
  };
  if (loading) {
    return <LoadingPage />;
  }

  const crmScripts = {
    preferred_language: {
      English: `Hello Sir/Madam, thank you for contacting Kryzen Biotech.
  
  My name is ${store?.Name} and I am a sales executive here.
  
  Before we begin, may I know which language is more comfortable for you — English, Hindi, or Marathi?`,

      Hindi: `नमस्कार सर / मैडम,
  कृपया Kryzen Biotech से संपर्क करने के लिए आपका धन्यवाद।
  
  मेरा नाम ${store?.Name} है और मैं यहाँ सेल्स एग्जीक्यूटिव के रूप में आपकी सहायता कर रहा हूँ।
  
  आगे बढ़ने से पहले, क्या आप बता सकते हैं कि आपके लिए कौन-सी भाषा ज्यादा सुविधाजनक रहेगी — हिंदी, अंग्रेज़ी या मराठी?`,

      Marathi: `नमस्कार सर / मॅडम,
  Kryzen Biotech शी संपर्क केल्याबद्दल धन्यवाद.
  z
  माझं नाव ${store?.Name} आहे आणि मी येथे सेल्स एक्झिक्युटिव आहे.
  
  सुरुवात करण्यापूर्वी तुम्हाला कोणती भाषा सोयीची आहे — मराठी, हिंदी की इंग्रजी?`,
    },

    first_name: {
      English: `We received your enquiry about Hydroponics / Training / Farm Setup through ${leadsInfo?.origin}.
  
  Before I guide you further, may I know your first name and last name please?
  
  Thank you for sharing that.`,

      Hindi: `हमें आपका Hydroponics / Training / Farm Setup से  संबंधित enquiry प्राप्त हुआ है।
  
  आगे सही तरीके से मार्गदर्शन देने से पहले, क्या मैं आपका पहला नाम और आखिरी नाम जान सकता हूँ?
  
  धन्यवाद यह जानकारी साझा करने के लिए।`,

      Marathi: `आपली Hydroponics / Training / Farm Setup] संबंधी enquiry आम्हाला ${leadsInfo?.origin} वरून मिळाली आहे.

आपल्याला पुढे योग्य मार्गदर्शन करण्यापूर्वी, कृपया आपले पहिले नाव आणि आडनाव सांगाल का?

(CRM मध्ये माहिती भरा)

धन्यवाद [Name], ही माहिती दिल्याबद्दल.`,
    },

    last_name: {
      English: `We received your enquiry about Hydroponics / Training / Farm Setup through ${leadsInfo?.origin}.
    
    Before I guide you further, may I know your first name and last name please?
    
    Thank you for sharing that.`,

      Hindi: `हमें आपका Hydroponics / Training / Farm Setup से संबंधित enquiry प्राप्त हुआ है।
    
    आगे सही तरीके से मार्गदर्शन देने से पहले, क्या मैं आपका पहला नाम और आखिरी नाम जान सकता हूँ?
    
    धन्यवाद यह जानकारी साझा करने के लिए।`,

      Marathi: `आपली Hydroponics / Training / Farm Setup संबंधी enquiry आम्हाला ${leadsInfo?.origin} वरून मिळाली आहे.
  
  आपल्याला पुढे योग्य मार्गदर्शन करण्यापूर्वी, कृपया आपले पहिले नाव आणि आडनाव सांगाल का?
  
  (CRM मध्ये माहिती भरा)
  
  धन्यवाद [${leadsInfo?.full_name}, ही माहिती दिल्याबद्दल.`,
    },

    email: {
      English: `I can send you details via email, kindly help me with your email id.`,

      Hindi: `मैं आपको पूरी जानकारी ईमेल के माध्यम से भेज सकता हूँ।
कृपया अपना ईमेल आईडी शेयर कर दीजिए, ताकि मैं आपको सभी details भेज सकूँ।`,

      Marathi: `मी आपल्याला सर्व माहिती ईमेलवर पाठवू शकतो.
कृपया आपला ईमेल आयडी सांगाल का, जेणेकरून मी आपल्याला सर्व details पाठवू शकेन.`,
    },

    enquiry_related_to: {
      English: `Understand the intent of client and select drop down option.`,

      Hindi: `ग्राहक के उत्तर के अनुसार CRM में सही विकल्प चुनें।`,
      Marathi: `ग्राहकाच्या उत्तरानुसार CRM मध्ये योग्य पर्याय निवडा`,
    },

    prior_knowledge_of_farming: {
      English: `To guide you properly, I would like to ask a quick question.
  
  Do you currently have any experience in farming or agriculture?`,

      Hindi: `आपको सही तरीके से मार्गदर्शन देने के लिए मैं आपसे कुछ छोटे-छोटे सवाल पूछना चाहूँगा।

सबसे पहले, क्या आपका फार्मिंग या एग्रीकल्चर में पहले से कोई अनुभव या बैकग्राउंड है?`,
      Marathi: `आपल्याला योग्य मार्गदर्शन देण्यासाठी मी काही छोटे प्रश्न विचारू इच्छितो.

सर्वप्रथम, आपल्याला शेती किंवा कृषी क्षेत्राचा आधी काही अनुभव किंवा पार्श्वभूमी आहे का?`,
    },

    interested_in: {
      English: `What would you mainly like to explore today?
  
  • Learning hydroponics
  • Practical training
  • Setting up a hydroponic farm
  • Just exploring options`,

      Hindi: `आज आप मुख्य रूप से किस बारे में जानकारी लेना चाहते हैं?
  
  • Hydroponics सीखना
  • Practical training
  • Farm setup करना
  • सिर्फ options explore करना`,

      Marathi: `आज आपण मुख्यतः कशाबद्दल माहिती घ्यायची आहे?

• Hydroponics सविस्तर शिकायचे आहे
• Practical hydroponic training ला सहभागी व्हायचे आहे
• Hydroponic farm setup करायचा आहे
• सध्या फक्त माहिती किंवा पर्याय पाहत आहात`,
    },

    email: {
      English: `I can send you details via email. Kindly share your email id ?`,

      Hindi: `मैं आपको पूरी जानकारी ईमेल के माध्यम से भेज सकता हूँ।
  कृपया अपना ईमेल आईडी साझा करें।`,
      Marathi: `मी आपल्याला सर्व माहिती ईमेलवर पाठवू शकतो.
कृपया आपला ईमेल आयडी सांगाल का, जेणेकरून मी आपल्याला सर्व details पाठवू शकेन.`,
    },

    contact_number: {
      English: `I can also send you details on WhatsApp. Is this number available on WhatsApp?`,

      Hindi: `मैं आपको सारी जानकारी WhatsApp पर भी भेज सकता हूँ।
क्या जिस नंबर पर मैंने कॉल किया है, वही नंबर WhatsApp पर उपलब्ध है??`,
      Marathi: `मी आपल्याला सर्व माहिती WhatsApp वर देखील पाठवू शकतो.
ज्या नंबरवर मी कॉल केला आहे, तोच नंबर WhatsApp वर उपलब्ध आहे का?`,
    },

    whatsapp_number: {
      English: `Do you have any alternative number, on which You want me to send whatsapp?`,

      Hindi: `क्या आपके पास कोई दूसरा नंबर है जिस पर आप चाहते हैं कि मैं WhatsApp पर जानकारी भेजूँ?`,
      Marathi: `आपल्याकडे दुसरा कोणता नंबर आहे का, ज्यावर मी WhatsApp वर माहिती पाठवू शकतो?`,
    },

    farm_construction_location: {
      English: `In which city or location are you planning to build the farm?`,

      Hindi: `कृपया बताइए, आप किस शहर या लोकेशन में farm बनाना चाहते हैं?`,
      Marathi: `कृपया सांगा, आपण कोणत्या शहरात किंवा लोकेशनवर farm उभारण्याचा विचार करत आहात?`,
    },

    farm_land_type: {
      English: `What type of land do you have — farm land, NA plot, terrace, or indoor space?`,

      Hindi: `आपके पास किस प्रकार की जगह उपलब्ध है — फार्म लैंड, NA प्लॉट, टेरेस या इनडोर स्पेस?`,
      Marathi: `आपल्याकडे कोणत्या प्रकारची जागा उपलब्ध आहे — शेती जमीन, NA प्लॉट, टेरेस की इनडोर स्पेस?`,
    },

    farm_construction_state: {
      English: `Can you also help me with name of state?`,

      Hindi: `क्या आप राज्य का नाम भी बता सकते हैं, जहाँ आप farm setup करने की योजना बना रहे हैं?`,
      Marathi: `आपण राज्याचे नावही सांगू शकता का, जिथे आपण farm setup करण्याचा विचार करत आहात?`,
    },

    total_area_available: {
      English: `What is the approximate area available?`,

      Hindi: `कृपया बताइए, आपके पास लगभग कितने क्षेत्रफल (area) की जगह उपलब्ध है?`,
      Marathi: `कृपया सांगा, आपल्याकडे अंदाजे किती क्षेत्रफळाची (area) जागा उपलब्ध आहे?`,
    },

    tentative_start_time: {
      English: `When are you planning to start the project — immediately, within 3 months, within 6 months, or later?`,
      Hindi: `आप इस प्रोजेक्ट को कब शुरू करने की योजना बना रहे हैं — तुरंत, 3 महीनों के अंदर, 6 महीनों के अंदर, या बाद में?`,
      Marathi: `आपण हा प्रोजेक्ट कधी सुरू करण्याचा विचार करत आहात — ताबडतोब, 3 महिन्यांच्या आत, 6 महिन्यांच्या आत, की नंतर?`,
    },

    looking_for_loan: {
      English: `Are you planning to take a bank loan for the project?`,

      Hindi: `क्या आप इस प्रोजेक्ट के लिए बैंक लोन लेने की योजना बना रहे हैं?`,
      Marathi: `आपण या प्रोजेक्टसाठी बँक लोन घेण्याचा विचार करत आहात का?`,
    },
  };

  const FormEffects = () => {
    const { values, setFieldValue, setFieldTouched } = useFormikContext();

    // 🔹 1. Handle enquiry_related_to change
    useEffect(() => {
      const isNotRelatedToSales = values.enquiry_related_to !== "Sales";

      if (isNotRelatedToSales) {
        const resetFields = {
          prior_knowledge_of_farming: "",
          interested_in: [],
          looking_for_loan: false,
          farm_construction_location: "",
          farm_construction_state: "",
          farm_land_type: "",
          total_area_available: "",
          facilities: [],
          tentative_start_time: "",
        };

        Object.keys(resetFields).forEach((key) => {
          if (values[key] !== resetFields[key]) {
            setFieldValue(key, resetFields[key], false);
            setFieldTouched(key, false, false);
          }
        });
      }
    }, [values.enquiry_related_to]);

    // 🔹 2. Handle interested_in change
    useEffect(() => {
      const isFarmConstruction =
        values.interested_in?.includes("farm construction");

      // Only reset when it's Sales + not farm construction
      if (values.enquiry_related_to === "Sales" && !isFarmConstruction) {
        const resetFields = {
          looking_for_loan: false,
          farm_land_type: "",
          total_area_available: "",
          facilities: [],
          tentative_start_time: "",
        };

        Object.keys(resetFields).forEach((key) => {
          if (values[key] !== resetFields[key]) {
            setFieldValue(key, resetFields[key], false);
            setFieldTouched(key, false, false);
          }
        });
      }
    }, [values.interested_in]);

    return null;
  };
  const getScoreColor = (score) => {
    if (score >= 80) return "#28a745"; // green
    if (score >= 50) return "#ffc107"; // yellow
    return "#dc3545"; // red
  };

  const getLeadType = (score) => {
    if (score >= 80) return "🔥 Hot";
    if (score >= 50) return "⚡ Warm";
    return "❄️ Cold";
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Leads</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 ">
              <div className="card my-4">
                <div className="card-header">
                  <h2 className="page-title">Create New Leads</h2>
                </div>

                <Formik
                  initialValues={leadsInfo}
                  validationSchema={NewLeadSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <FormEffects />
                      <div className="row">
                        {/* <div className="col-12 col-md-3 col-lg-3 m-md-3 m-lg-3 m-0">
                          <div className="card mx-2">
                            <div className="card-header">
                              <h4>CRM Script</h4>
                            </div>

                            <div className="card-body">
                              {activeField &&
                              props.values.preferred_language ? (
                                <p style={{ whiteSpace: "pre-line" }}>
                                  {
                                    crmScripts[activeField]?.[
                                      props.values.preferred_language
                                    ]
                                  }
                                </p>
                              ) : (
                                <p className="text-muted">
                                  Select a field to see script
                                </p>
                              )}
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12 col-md-3 col-lg-3 m-md-3 m-lg-3 m-0">
                          <div
                            className="card mx-2"
                            style={{
                              position: "sticky",
                              top: "100px",
                              maxHeight: "80vh",
                              overflowY: "auto",
                            }}
                          >
                            <div className="">
                              <div className=" text-center p-1">
                                <h2>CRM Script</h2>
                              </div>
                              <hr className="m-0 p-0"></hr>

                              <div className="d-flex justify-content-between align-items-center gap- p-1">
                                {/* LEFT: Title */}

                                <div className="p-2">
                                  {/* Score */}
                                  <span
                                    className="badge"
                                    style={{
                                      fontSize: "15px",
                                      padding: "5px 10px",
                                      borderRadius: "20px",
                                      backgroundColor: getScoreColor(
                                        calculateLeadScore(props.values)
                                      ),
                                      color: "#fff",
                                    }}
                                  >
                                    {calculateLeadScore(props.values)} / 100
                                  </span>
                                </div>

                                <div>
                                  {/* Lead Type */}
                                  <span
                                    className="badge bg-light"
                                    style={{
                                      fontSize: "14px",
                                      padding: "6px 12px",
                                      borderRadius: "20px",
                                      border: "1px solid #ddd",
                                    }}
                                  >
                                    {getLeadType(
                                      calculateLeadScore(props.values)
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <hr className="m-0 p-0"></hr>

                            <div className="card-body">
                              {props.values.preferred_language ? (
                                <>
                                  <p
                                    style={{
                                      whiteSpace: "pre-line",
                                      fontSize: "23px",
                                    }}
                                  >
                                    {crmScripts[activeField]?.[
                                      props.values.preferred_language
                                    ] || "No script available for this field"}
                                  </p>
                                </>
                              ) : (
                                <p className="text-muted">
                                  Select language first to see CRM script
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 m-md-3 m-lg-3 m-0">
                          <div className="card-body border mb-2">
                            <h1>Basic Information</h1>
                            <hr></hr>
                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                Select language
                              </label>
                              <div className="w-100 col">
                                <CustomSelect
                                  type="text"
                                  name="preferred_language"
                                  onFocus={() =>
                                    setActiveField("preferred_language")
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="English">English</option>
                                  <option value="Hindi">Hindi</option>
                                  <option value="Marathi">Marathi</option>
                                </CustomSelect>
                                {props.touched.preferred_language &&
                                  props.errors.preferred_language && (
                                    <p className="text-danger">
                                      {props.errors.preferred_language}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                First name
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="first_name"
                                  type="text"
                                  onFocus={() => setActiveField("first_name")}
                                />
                                {props.touched.first_name &&
                                  props.errors.first_name && (
                                    <p className="text-danger">
                                      {props.errors.first_name}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label">
                                Last name
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="last_name"
                                  type="text"
                                  onFocus={() => setActiveField("last_name")}
                                />
                                {props.touched.last_name &&
                                  props.errors.last_name && (
                                    <p className="text-danger">
                                      {props.errors.last_name}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 ">
                                Email
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  type="email"
                                  name="email"
                                  onFocus={() => setActiveField("email")}
                                />
                                {props.touched.email && props.errors.email && (
                                  <p className="text-danger">
                                    {props.errors.email}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                Contact number
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="contact_number"
                                  type="text"
                                  onFocus={() =>
                                    setActiveField("contact_number")
                                  }
                                />
                                {props.touched.contact_number &&
                                  props.errors.contact_number && (
                                    <p className="text-danger">
                                      {props.errors.contact_number}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label  col-3">
                                Whatsapp number
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="whatsapp_number"
                                  type="text"
                                  onFocus={() =>
                                    setActiveField("whatsapp_number")
                                  }
                                />
                                {props.touched.whatsapp_number &&
                                  props.errors.whatsapp_number && (
                                    <p className="text-danger">
                                      {props.errors.whatsapp_number}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 ">
                                Notes
                              </label>
                              <div className="w-100 col">
                                <CustomTextArea type="textarea" name="notes" />

                                {props.touched.notes && props.errors.notes && (
                                  <p className="text-danger">
                                    {props.errors.notes}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                Enquiry Related to
                              </label>
                              <div className="w-100 col">
                                <CustomSelect
                                  type="text"
                                  name="enquiry_related_to"
                                  onFocus={() =>
                                    setActiveField("enquiry_related_to")
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Sales">Sales</option>
                                  <option value="Association">
                                    Association
                                  </option>
                                  <option value="Other Products">
                                    Other Products
                                  </option>
                                  <option value="Vendor">Vendor</option>
                                  <option value="Career">Career</option>
                                  <option value="Not Interested">
                                    Not Interested
                                  </option>
                                </CustomSelect>
                                {props.touched.enquiry_related_to &&
                                  props.errors.enquiry_related_to && (
                                    <p className="text-danger">
                                      {props.errors.enquiry_related_to}
                                    </p>
                                  )}
                              </div>
                            </div>
                            {/* <div className="mb-3 row">
                              <label className="w-25 form-label col-3 ">
                                Notes
                              </label>
                              <div className="w-100 col">
                                <CustomTextArea type="textarea" name="notes" />

                                {props.touched.notes && props.errors.notes && (
                                  <p className="text-danger">
                                    {props.errors.notes}
                                  </p>
                                )}
                              </div>
                            </div> */}

                            {props?.values?.enquiry_related_to === "Sales" && (
                              <div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Prior Knowledge of Farming
                                  </label>

                                  <div className="w-100 col">
                                    <div className="form-check">
                                      <CustomRadioButton
                                        type="radio"
                                        name="prior_knowledge_of_farming"
                                        value="Yes"
                                        onFocus={() =>
                                          setActiveField(
                                            "prior_knowledge_of_farming"
                                          )
                                        }
                                      />
                                      <label className="ms-2">Yes</label>
                                    </div>

                                    <div className="form-check">
                                      <CustomRadioButton
                                        type="radio"
                                        name="prior_knowledge_of_farming"
                                        value="No"
                                        onFocus={() =>
                                          setActiveField(
                                            "prior_knowledge_of_farming"
                                          )
                                        }
                                      />
                                      <label className="ms-2">No</label>
                                    </div>

                                    <div className="form-check">
                                      <CustomRadioButton
                                        type="radio"
                                        name="prior_knowledge_of_farming"
                                        value="Somewhat"
                                        width={"20px"}
                                        height={"20px"}
                                        onFocus={() =>
                                          setActiveField(
                                            "prior_knowledge_of_farming"
                                          )
                                        }
                                      />
                                      <label className="ms-2">Somewhat</label>
                                    </div>

                                    {props.touched.prior_knowledge_of_farming &&
                                      props.errors
                                        .prior_knowledge_of_farming && (
                                        <p className="text-danger">
                                          {
                                            props.errors
                                              .prior_knowledge_of_farming
                                          }
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Customer Type
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name="customer_type"
                                      onFocus={() =>
                                        setActiveField("customer_type")
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Farmer">Farmer</option>
                                      <option value="Investor">Investor</option>
                                      <option value="Hobby">Hobby</option>
                                      <option value="Career">Career</option>
                                      <option value="Student">Student</option>
                                    </CustomSelect>
                                    {props.touched.customer_type &&
                                      props.errors.customer_type && (
                                        <p className="text-danger">
                                          {props.errors.customer_type}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Experience level
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name="experience_level"
                                      onFocus={() =>
                                        setActiveField("experience_level")
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Beginner">Beginner</option>
                                      <option value="Intermediate">
                                        Intermediate
                                      </option>
                                      <option value="Advanced">Advanced</option>
                                      <option value="Career">Career</option>
                                    </CustomSelect>
                                    {props.touched.experience_level &&
                                      props.errors.experience_level && (
                                        <p className="text-danger">
                                          {props.errors.experience_level}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Occupation
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name="occupation"
                                      onFocus={() =>
                                        setActiveField("occupation")
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Business">Business</option>
                                      <option value="Working">Working</option>
                                    </CustomSelect>
                                    {props.touched.occupation &&
                                      props.errors.occupation && (
                                        <p className="text-danger">
                                          {props.errors.occupation}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Location Type
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name="location_type"
                                      onFocus={() =>
                                        setActiveField("location_type")
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Urban">Urban</option>
                                      <option value="Semi-Urban">
                                        Semi-Urban
                                      </option>
                                      <option value="Rural">Rural</option>
                                    </CustomSelect>
                                    {props.touched.location_type &&
                                      props.errors.location_type && (
                                        <p className="text-danger">
                                          {props.errors.location_type}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label  col-3">
                                    Land Available
                                  </label>

                                  <div className="w-100 col">
                                    <div className="form-check">
                                      <CustomRadioButton
                                        type="radio"
                                        name="land_available"
                                        value="Yes"
                                        onFocus={() =>
                                          setActiveField("land_available")
                                        }
                                      />
                                      <label className="ms-2">Yes</label>
                                    </div>

                                    <div className="form-check">
                                      <CustomRadioButton
                                        type="radio"
                                        name="land_available "
                                        value="No"
                                        onFocus={() =>
                                          setActiveField("land_available")
                                        }
                                      />
                                      <label className="ms-2">No</label>
                                    </div>

                                    {props.touched.land_available &&
                                      props.errors.land_available && (
                                        <p className="text-danger">
                                          {props.errors.land_available}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <hr></hr>
                                <h1>Interested In</h1>
                                <hr></hr>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Interested in
                                  </label>
                                  <div className="w-100 col">
                                    <div>
                                      <div className="d-flex">
                                        <label className="form-check-inline">
                                          <CustomCheckbox
                                            type="checkbox"
                                            name="interested_in"
                                            width={"20px"}
                                            height={"20px"}
                                            value="learning about Hydroponics"
                                            onFocus={() =>
                                              setActiveField("interested_in")
                                            }
                                          />
                                        </label>
                                        <span className="form-check-label">
                                          Learning about Hydroponics
                                        </span>
                                      </div>
                                      {props.values.interested_in &&
                                        props.values.interested_in.includes(
                                          "learning about Hydroponics"
                                        ) && (
                                          <p>
                                            More details on{" "}
                                            <span className="text-blue">
                                              hydroponicmasterclass.com
                                            </span>{" "}
                                            website
                                          </p>
                                        )}
                                    </div>

                                    <div>
                                      <div className="d-flex">
                                        <label className="form-check-inline">
                                          <CustomCheckbox
                                            type="checkbox"
                                            width={"20px"}
                                            height={"20px"}
                                            name="interested_in"
                                            value="farm construction"
                                            onFocus={() =>
                                              setActiveField("interested_in")
                                            }
                                          />
                                        </label>
                                        <span className="form-check-label">
                                          Farm Construction
                                        </span>
                                      </div>
                                    </div>
                                    {props.touched.interested_in &&
                                      props.errors.interested_in && (
                                        <p className="text-danger">
                                          {props.errors.interested_in}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                {props.values.interested_in.includes(
                                  "learning about Hydroponics"
                                ) &&
                                  !props.values.interested_in.includes(
                                    "farm construction"
                                  ) && (
                                    <div>
                                      {" "}
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label col-3">
                                          Location
                                        </label>

                                        <div className="w-100 col">
                                          <CustomInput
                                            type="text"
                                            name="farm_construction_location"
                                            onFocus={() =>
                                              setActiveField(
                                                "farm_construction_location"
                                              )
                                            }
                                          />

                                          {props.touched
                                            .farm_construction_location &&
                                            props.errors
                                              .farm_construction_location && (
                                              <p className="text-danger">
                                                {
                                                  props.errors
                                                    .farm_construction_location
                                                }
                                              </p>
                                            )}
                                        </div>
                                      </div>
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label col-3">
                                          State
                                        </label>

                                        <div className="w-100 col">
                                          <CustomInput
                                            type="text"
                                            name="farm_construction_state"
                                            onFocus={() =>
                                              setActiveField(
                                                "farm_construction_state"
                                              )
                                            }
                                          />

                                          {props.touched
                                            .farm_construction_state &&
                                            props.errors
                                              .farm_construction_state && (
                                              <p className="text-danger">
                                                {
                                                  props.errors
                                                    .farm_construction_state
                                                }
                                              </p>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                {props.values.interested_in.includes(
                                  "farm construction"
                                ) && (
                                  <div>
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label col-3">
                                        Looking for loan
                                      </label>
                                      <div className="w-100 col">
                                        <div>
                                          <div className="d-flex">
                                            <label className="form-check-inline">
                                              <CustomCheckbox
                                                type="checkbox"
                                                name="looking_for_loan"
                                                width={"20px"}
                                                height={"20px"}
                                                checked={
                                                  props.values.looking_for_loan
                                                }
                                                onFocus={() =>
                                                  setActiveField(
                                                    "looking_for_loan"
                                                  )
                                                }
                                                onChange={(e) =>
                                                  props.setFieldValue(
                                                    "looking_for_loan",
                                                    e.target.checked
                                                  )
                                                }
                                              />
                                            </label>
                                          </div>
                                        </div>
                                        {props.touched.looking_for_loan &&
                                          props.errors.looking_for_loan && (
                                            <p className="text-danger">
                                              {props.errors.looking_for_loan}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label col-3">
                                        Farm Construction Location
                                      </label>

                                      <div className="w-100 col">
                                        <CustomInput
                                          type="text"
                                          name="farm_construction_location"
                                          onFocus={() =>
                                            setActiveField(
                                              "farm_construction_location"
                                            )
                                          }
                                        />

                                        {props.touched
                                          .farm_construction_location &&
                                          props.errors
                                            .farm_construction_location && (
                                            <p className="text-danger">
                                              {
                                                props.errors
                                                  .farm_construction_location
                                              }
                                            </p>
                                          )}
                                      </div>
                                    </div>

                                    <div className="mb-3 row">
                                      <label className="w-25 form-label col-3">
                                        Farm Construction State
                                      </label>

                                      <div className="w-100 col">
                                        <CustomInput
                                          type="text"
                                          name="farm_construction_state"
                                          onFocus={() =>
                                            setActiveField(
                                              "farm_construction_state"
                                            )
                                          }
                                        />

                                        {props.touched
                                          .farm_construction_state &&
                                          props.errors
                                            .farm_construction_state && (
                                            <p className="text-danger">
                                              {
                                                props.errors
                                                  .farm_construction_state
                                              }
                                            </p>
                                          )}
                                      </div>
                                    </div>

                                    <div className="mb-3 row">
                                      <label className="w-25 form-label col-3">
                                        Farm Land Type
                                      </label>

                                      <div className="w-100 col">
                                        <CustomInput
                                          type="text"
                                          name="farm_land_type"
                                        />

                                        {props.touched.farm_land_type &&
                                          props.errors.farm_land_type && (
                                            <p className="text-danger">
                                              {props.errors.farm_land_type}
                                            </p>
                                          )}
                                      </div>
                                    </div>

                                    <div className="mb-3 row">
                                      <label className="w-25 form-label col-3">
                                        Total Area Available
                                      </label>

                                      <div className="w-100 col">
                                        <CustomInput
                                          type="text"
                                          name="total_area_available"
                                        />

                                        {props.touched.total_area_available &&
                                          props.errors.total_area_available && (
                                            <p className="text-danger">
                                              {
                                                props.errors
                                                  .total_area_available
                                              }
                                            </p>
                                          )}
                                      </div>
                                    </div>

                                    <div className="mb-3 row">
                                      <label className="w-25 form-label col-3">
                                        Facilities
                                      </label>

                                      <div className="w-100 col">
                                        <div className="d-flex align-items-center mb-2">
                                          <CustomCheckbox
                                            type="checkbox"
                                            name="facilities"
                                            value="water Available"
                                            width={"20px"}
                                            height={"20px"}
                                          />
                                          <span className="ms-2">
                                            Water Available
                                          </span>
                                        </div>

                                        <div className="d-flex align-items-center">
                                          <CustomCheckbox
                                            type="checkbox"
                                            name="facilities"
                                            value="electricity available"
                                            width={"20px"}
                                            height={"20px"}
                                          />
                                          <span className="ms-2">
                                            Electricity Available
                                          </span>
                                        </div>

                                        <div className="d-flex align-items-center mt-2">
                                          <CustomCheckbox
                                            type="checkbox"
                                            name="facilities"
                                            value="under planning"
                                            width={"20px"}
                                            height={"20px"}
                                          />
                                          <span className="ms-2">
                                            Under Planning
                                          </span>
                                        </div>

                                        {props.touched.facilities &&
                                          props.errors.facilities && (
                                            <p className="text-danger">
                                              {props.errors.facilities}
                                            </p>
                                          )}
                                      </div>
                                    </div>

                                    <div className="mb-3 row">
                                      <label className="w-25 form-label required col-3">
                                        Tentative start time
                                      </label>
                                      <div className="w-100 col">
                                        <CustomSelect
                                          type="text"
                                          name="tentative_start_time"
                                          onFocus={() =>
                                            setActiveField(
                                              "tentative_start_time"
                                            )
                                          }
                                        >
                                          <option value="">Select</option>
                                          <option value="2 Weeks">
                                            2 Weeks
                                          </option>
                                          <option value="1 Month">
                                            1 Month
                                          </option>
                                          <option value="2 -3 Months">
                                            2 -3 Months
                                          </option>
                                          <option value="3 - 6 Months">
                                            3 - 6 Months
                                          </option>
                                        </CustomSelect>
                                        {props.touched.tentative_start_time &&
                                          props.errors.tentative_start_time && (
                                            <p className="text-danger">
                                              {
                                                props.errors
                                                  .tentative_start_time
                                              }
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* <hr></hr>
                                <h1>Lead Details</h1>
                                <hr></hr>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Lead generated from
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name="lead_genrated_from"
                                    >
                                      <option value="">Select</option>
                                      <option value="myoperator">
                                        MyOperator
                                      </option>
                                      <option value="hydroponic masterclass">
                                        Hydroponic Masterclass
                                      </option>
                                      <option value="whatsapp">WhatsApp</option>
                                      <option value="walkin">WalkIn</option>
                                      <option value="enquiry">Enquiry</option>
                                      <option value="repeat customer">
                                        Repeat Customer
                                      </option>
                                      <option value="other">Other</option>
                                    </CustomSelect>
                                    {props.touched.lead_genrated_from &&
                                      props.errors.lead_genrated_from && (
                                        <p className="text-danger">
                                          {props.errors.lead_genrated_from}
                                        </p>
                                      )}
                                  </div>
                                </div> */}

                                {/* <div className="mb-3 row">
                                  <label className="w-25 form-label col-3 required">
                                    Lead status
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name="lead_status"
                                    >
                                      <option value="">Select</option>
                                      <option value="cold">
                                        Cold (Not Interested)
                                      </option>
                                      <option value="hot">Hot</option>
                                      <option value="warm">
                                        Warm (May be)
                                      </option>
                                    </CustomSelect>
                                    {props.touched.lead_status &&
                                      props.errors.lead_status && (
                                        <p className="text-danger">
                                          {props.errors.lead_status}
                                        </p>
                                      )}
                                  </div>
                                </div> */}
                                <hr />
                                <h1>Follow UP</h1>
                                <hr />

                                <FieldArray name="followUp">
                                  {({ push, remove }) => (
                                    <div>
                                      {props.values.followUp?.map(
                                        (followup, index) => (
                                          <div
                                            key={index}
                                            className="card mb-4 shadow-sm"
                                          >
                                            <div className="card-body">
                                              <div className="row g-4">
                                                {/* Message */}
                                                <div className="col-md-4">
                                                  <label className="form-label fw-bold required">
                                                    Message
                                                  </label>

                                                  <CustomTextArea
                                                    rows={6}
                                                    name={`followUp[${index}].followUp`}
                                                  />

                                                  {props?.touched?.followUp?.[
                                                    index
                                                  ]?.followUp &&
                                                    props?.errors?.followUp?.[
                                                      index
                                                    ]?.followUp && (
                                                      <p className="text-danger">
                                                        {
                                                          props?.errors
                                                            ?.followUp?.[index]
                                                            ?.followUp
                                                        }
                                                      </p>
                                                    )}

                                                  <p className="text-warning small">
                                                    Write as much precise and
                                                    accurate information as you
                                                    can.
                                                  </p>
                                                </div>

                                                {/* Followup Status */}
                                                <div className="col-md-4">
                                                  <label className="form-label fw-bold">
                                                    Followup Status
                                                  </label>

                                                  <div
                                                    className="border rounded p-3 bg-light"
                                                    style={{
                                                      maxHeight: "200px",
                                                      overflowY: "auto",
                                                    }}
                                                  >
                                                    {/* <div className="form-check mb-2">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Call not received"
                                                      />
                                                      <label className="ms-2">
                                                        Call not received
                                                      </label>
                                                    </div> */}

                                                    {/* <div className="form-check mb-2">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Mobile not reachable"
                                                      />
                                                      <label className="ms-2">
                                                        Mobile not reachable
                                                      </label>
                                                    </div> */}

                                                    <div className="form-check mb-2">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Lead on whatsapp"
                                                      />
                                                      <label className="ms-2">
                                                        Lead on WhatsApp
                                                      </label>
                                                    </div>

                                                    <div className="form-check mb-2">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="shared quotation"
                                                      />
                                                      <label className="ms-2">
                                                        Shared quotation
                                                      </label>
                                                    </div>

                                                    <div className="form-check mb-2">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="farm/office visit"
                                                      />
                                                      <label className="ms-2">
                                                        Farm/Office visit
                                                      </label>
                                                    </div>

                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Shared details"
                                                      />
                                                      <label className="ms-2">
                                                        Shared details
                                                      </label>
                                                    </div>

                                                    {/* <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Connected no interest"
                                                      />
                                                      <label className="ms-2">
                                                        Connected no interest
                                                      </label>
                                                    </div>
                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Call back later"
                                                      />
                                                      <label className="ms-2">
                                                        Call back later
                                                      </label>
                                                    </div>
                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Interested need details"
                                                      />
                                                      <label className="ms-2">
                                                        Interested need details
                                                      </label>
                                                    </div>
                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Discussion in progress"
                                                      />
                                                      <label className="ms-2">
                                                        Discussion in progress
                                                      </label>
                                                    </div>
                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Waiting data on teammate"
                                                      />
                                                      <label className="ms-2">
                                                        Waiting data on teammate
                                                      </label>
                                                    </div>
                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Waiting data on client"
                                                      />
                                                      <label className="ms-2">
                                                        Waiting data on client
                                                      </label>
                                                    </div>

                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Office site visit scheduled"
                                                      />
                                                      <label className="ms-2">
                                                        Office site visit
                                                        scheduled
                                                      </label>
                                                    </div>

                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Negotiation in progress"
                                                      />
                                                      <label className="ms-2">
                                                        Negotiation in progress
                                                      </label>
                                                    </div>

                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Ready to close"
                                                      />
                                                      <label className="ms-2">
                                                        Ready to close
                                                      </label>
                                                    </div>

                                                    <div className="form-check">
                                                      <CustomRadioButton
                                                        type="radio"
                                                        name={`followUp[${index}].followUpStatus`}
                                                        value="Not interested in construction"
                                                      />
                                                      <label className="ms-2">
                                                        Not interested in
                                                        construction
                                                      </label>
                                                    </div> */}
                                                  </div>
                                                </div>

                                                {/* Lead Generated From */}
                                                {/* <div className="col-md-4">
                                                  <label className="form-label fw-bold">
                                                    Followup Type
                                                  </label>

                                                  <CustomSelect
                                                    name={`followUp[${index}].followUpDate`}
                                                    value={
                                                      props.values.followUp[
                                                        index
                                                      ].followUpDate
                                                    }
                                                  >
                                                    <option value="">
                                                      Select
                                                    </option>
                                                    <option value="followup today">
                                                      Today's Followups
                                                    </option>
                                                    <option value="followup in one day">
                                                      Tommorrows Followup
                                                    </option>
                                                    <option value="followup in two day">
                                                      Followup In 2 Days
                                                    </option>
                                                    <option value="followup in four day">
                                                      Followup In 4 Days
                                                    </option>
                                                    <option value="followup in one week">
                                                      Followup Next Week
                                                    </option>
                                                    <option value="followup in two week">
                                                      Followup In Two Week
                                                    </option>
                                                    <option value="followup in one month">
                                                      Followup Next Month
                                                    </option>
                                                  </CustomSelect>

                                                  {props?.touched?.followUp?.[
                                                    index
                                                  ]?.followUpDate &&
                                                    props?.errors?.followUp?.[
                                                      index
                                                    ]?.followUpDate && (
                                                      <p className="text-danger">
                                                        {
                                                          props?.errors
                                                            ?.followUp?.[index]
                                                            ?.followUpDate
                                                        }
                                                      </p>
                                                    )}
                                                </div> */}
                                                <div className="col-md-4">
                                                  <div>
                                                    <label className="form-label fw-bold">
                                                      Follwup date
                                                    </label>
                                                    <div className="w-100 col">
                                                      <CustomInput
                                                        type="date"
                                                        name={`followUp[${index}].followUpDate`}
                                                        min={
                                                          new Date()
                                                            .toISOString()
                                                            .split("T")[0]
                                                        }
                                                        value={
                                                          props.values.followUp[
                                                            index
                                                          ].followUpDate
                                                        }
                                                      />
                                                      {props?.touched
                                                        ?.followUp?.[index]
                                                        ?.followUpDate &&
                                                        props?.errors
                                                          ?.followUp?.[index]
                                                          ?.followUpDate && (
                                                          <p className="text-danger">
                                                            {
                                                              props?.errors
                                                                ?.followUp?.[
                                                                index
                                                              ]?.followUpDate
                                                            }
                                                          </p>
                                                        )}
                                                    </div>
                                                  </div>
                                                  <p className="text-danger mb-0">
                                                    After your call, your
                                                    follow-up was examined. data
                                                    from the salestrail api and
                                                    call history.
                                                  </p>

                                                  <p className="text-warning">
                                                    Your follow-up was
                                                    automatically marked as
                                                    completed based on your call
                                                    record.
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}

                                      {/* Add Follow Up Button */}
                                      <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={() => {
                                          const newFollowUpInfo = {
                                            followUp: "",
                                            followUpStatus: "",
                                            followUpDate: "",
                                            videoCall: false,
                                            followupTaken: false,
                                            followupTakenDate: "",
                                            createdAt: new Date()
                                              .toISOString()
                                              .split("T")[0],
                                            followupDelay: "",
                                            createdBy: store.Name,
                                          };

                                          if (
                                            props.values.followUp.length === 0
                                          ) {
                                            push(newFollowUpInfo);
                                          } else if (
                                            props.values.followUp.length > 0 &&
                                            checkTouched(
                                              props.values.followUp[
                                                props.values.followUp.length - 1
                                              ]
                                            )
                                          ) {
                                            push(newFollowUpInfo);
                                          } else {
                                            Toast(
                                              "error",
                                              "Please fill all follow up details."
                                            );
                                          }
                                        }}
                                      >
                                        Add Follow Up
                                      </button>
                                    </div>
                                  )}
                                </FieldArray>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer d-flex justify-content-end">
                        <FormSubmitButton buttonText="Create Lead" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>{" "}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};
export default AddNewLeads;
